/* tslint:disable */

declare var Object: any;
export interface TsmarketplaceInterface {
  "id"?: number;
}

export class Tsmarketplace implements TsmarketplaceInterface {
  "id": number;
  constructor(data?: TsmarketplaceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tsmarketplace`.
   */
  public static getModelName() {
    return "Tsmarketplace";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tsmarketplace for dynamic purposes.
  **/
  public static factory(data: TsmarketplaceInterface): Tsmarketplace{
    return new Tsmarketplace(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tsmarketplace',
      plural: 'Tsmarketplaces',
      path: 'Tsmarketplaces',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tsmarketplace.ts